// extracted by mini-css-extract-plugin
export var snowflake = "snow-module--snowflake--4fce8";
export var snowflakesFall = "snow-module--snowflakes-fall--0d610";
export var snowflakesShake = "snow-module--snowflakes-shake--8d2e6";